import styled from 'styled-components';
import Colors from '~/styles/colors';

interface DividerProps {
  height?: number;
  width?: number;
}

export const ContainerModal = styled.div`
  width: 30vw;
  min-height: 30vh;
  max-height: 70vh;
`;

export const TitleModal = styled.h1`
  font-size: 22px;
  color: ${Colors.darkBlue};
  text-align: center;
  margin-bottom: 15px;
`;

export const Divider = styled.div<DividerProps>`
  ${({ height }) => (height ? `height: ${height}px;` : '')}
  ${({ width }) => (width ? `width: ${width}px;` : '')}
`;
